<template>
  <el-col :span="24" ref="trxContainer" v-loading.body="reopeningPo">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100;">
            {{ hasEditPermission ? 'EDIT' : 'VIEW'}} PURCHASE ORDER {{ (form && form.number) ? form.number : '' }}
            ({{ originalHeader && originalHeader.status ? originalHeader.status : '' }})
          </h2>
        </el-row>
      </el-col>
      <template>
        <el-button :disabled="disablePrevButton || isSaving" :loading="loadingPrev" @click.stop="pageNavigation('prev')" size="small">Previous</el-button>
        <el-button :disabled="disableNextButton || isSaving" class="mr-5" :loading="loadingNext" @click.stop="pageNavigation('next')" size="small">Next</el-button>
      </template>
      <DataEntryButtons
        :showProscanToggle="true"
        :proscanFileVisible="proscanFileVisible"
        @toggleProscanFile="toggleProscanFile"
        :status="originalHeader.status"
        :isReadOnly="readOnly"
        :isSaving="isSaving"
        :isSaveable="isSaveable"
        :hasBeenChanged="hasBeenChanged"
        :isBalanced="['POSTED', 'CLOSED', 'VOIDED'].includes(originalHeader.status) ? true : transactionIsBalanced"
        :transactionType="transactionType"
        :converted_to_ap="originalHeader.converted_to_ap"
        :hasPermission="hasPermission"
        :allowDraftFileUpload="true"
        @addNew="addNew"
        @toggleReadOnly="toggleReadOnly"
        @dropdownClick="handleDropdownClick"
        @goBack="goBack"
        @auditBtnClick="handleSubmit(true, { status: 'AUDITED' })"
        @postBtnClick="showConfirmationDialog()"
        @submit="handleSubmit"
        @convertToAP="convertToAP"
        @otherActions="otherActions"
        :numberOfFiles="numberOfFiles"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
      <el-row justify="start" align="start" type="flex" class="trx-header" ref="trxHeaderContainer">
        <el-col :span="10" v-if="showProscanFile" class="proscan-pane-col">
          <ProscanFileViewer
            class="proscan-pane"
            :files="proscanFiles"
            :transactionNumber="originalHeader.number"
            :primaryFileId="proscanFileId" />
        </el-col>
        <el-col :span="showProscanFile ? 14 : 24">
        <el-row justify="start" align="start" :type="showProscanFile ? '' : 'flex'">
      <el-col :span="showProscanFile ? 24 : 8" style="margin-right: 10px">
        <el-row justify="start" align="start" type="flex">
          <HeaderFields
            title="Vendor"
            :fields="fields.vendor"
            :form="form"
            :idPrefix="'a-'"
            :nonAsyncSuggestions.sync="nonAsyncSuggestions"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'b-'"
            :nonAsyncSuggestions.sync="nonAsyncSuggestions"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="showProscanFile ? 24 : 8" :style="showProscanFile ? '' : 'margin: 0 10px;'">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="PO Data"
            :fields="fields.transactionData"
            :form="form"
            :idPrefix="'c-'"
            :nonAsyncSuggestions.sync="nonAsyncSuggestions"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @acBackspaceEvent="updateForm"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="showProscanFile ? 24 : 8" :style="showProscanFile ? '' : 'margin-left: 10px;'">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Info"
            :fields="fields.transactionInfo"
            :form="form"
            :lines="lines"
            :transactionType="this.transactionType.name"
            :idPrefix="'d-'"
            :nonAsyncSuggestions.sync="nonAsyncSuggestions"
            :modalOpen="dialogVisible"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
        </el-row>
        </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded && !linesLoading"
        entityType="po"
        ref="distribution-lines"
        :fields="lineFields"
        :readOnly="readOnly || isSaving"
        :existingLines="lines"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :initLines="20"
        :closedPoLineToUpdate="closedPoLineToUpdate"
        :showClosePoBtn="poCanBeClosed"
        :showDeletePoBtn="poCanBeDeleted"
        :showReopenPoBtn="poCanBeReopen"
        :hasEditPermission="hasEditPermission"
        :hasDeletePermission="hasDeletePermission"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @resetLineToUpdate="resetClosedPoLineToUpdate"
        @closeLine="handleCloseLine"
        @reopenline="handleReopenLine"
        @reopenPo="reOpenPO"
        @closePo="handleClosePoModalVisible"
        @deletePo="handleDeletePoModalVisible"
        @updateLines="updateLines"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      :visible.sync="dialogVisible"
      size="tiny"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Do you wish to save your changes?
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" @click="cancelExit">
          Cancel
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="goBack(true)">
          No
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="handleSubmit(false)">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Close line"
      :visible.sync="closeLineModalVisible"
      size="tiny"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <span>
        Are you sure you want to close line?
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" type="primary" @click="cancelCloseLine" :disabled="closingLine">
          No
        </el-button>
        <el-button type="primary" @click="closeLine" :loading="closingLine">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Close Purchase Order"
      :visible.sync="closePoModalVisible"
      size="tiny"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <span>
        Are you sure you want to close all remaining lines for this purchase order?<br />
        There is {{ sumLinesAmounts }} remaining.
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" type="primary" :disabled="closingPo" @click="cancelClosePo">
          No
        </el-button>
        <el-button type="primary" :loading="closingPo" @click="closePo">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Delete Purchase Order"
      :visible.sync="deletePoModalVisible"
      size="tiny"
      :show-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <span>
        Are you sure you want to delete this purchase order?
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" type="primary" :disabled="deletingPo" @click="cancelDeletePo">
          No
        </el-button>
        <el-button type="primary" :loading="deletingPo" @click="deletePo">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <NewBatch :hasCreatePermission="hasCreateBatchPermission" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <CustomerVendorForm :type="customerVendorFormType" :modelId="modelId" @updateModelIdProp="updateVendorModelId" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <el-dialog
      id="docs-dialog"
      title="View/Upload Documents"
      size="small"
      top="10%"
      :visible.sync="dropzoneVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <document-dialog
        :transaction="form"
        :dz-options="setupDropzoneOptions()"
        @upload-success="dzSuccess(); refreshProscanFiles()"
        @upload-error="dzFailure"
        @upload-remove="dzRemove"
      />
    </el-dialog>
    <DcConfirmationDialog
      :originalLines="originalLines"
      :lineDeltas="lineDeltas"
      :lineFields="lineFields"
      :visible="dcConfirmationDialogVisible"
      :allDcs="allDcs"
      :newDcs="newDcs"
      :loading="creatingDc"
      @cancel="() => showDcConfirmationDialog(false)"
      @confirm="confirmDcSubmit"
    />
    <DcViewDialog
      :viewedDcId="viewedDcId"
      :viewableDcs="viewableDcs"
      :showOrClose="viewDc"
      :trxType="transactionType.name"
      :lineFields="lineFields"
      :trxId="originalHeader.id"
    />
    <el-dialog
      title=""
      :visible.sync="sendEmailVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      @close="closeSendEmailModal">
      <el-row type="flex" align="middle" justify="end" style="border-bottom: 1px solid lightgrey;">
        <HeaderInfoText :colspan="12" title="Send Email" />
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button type="primary" @click="cancelSendEmail" style="margin: 0px 15px 10px 0px;">Cancel</el-button>
            <el-button type="primary" @click="sendEmail" style="margin: 0px 15px 10px 0px;">Send Email</el-button>
          </el-row>
        </el-col>
      </el-row>
      <nacha-po-conf-list
        v-show="sendEmailVisible && selectedPos && !emailLoading"
        name="nacha_po_conf_list"
        ref="nacha_po_conf_list"
        :allow-edit="true"
        :allow-notify="false"
        :width="width"
        :height="height"
        :row-data="selectedPos"
        @onSelect="handleSelectedConf"
        @updateCCMail="handleUpdateCCMail"
        @updateFileAttachment="handleUpdateFileAttachment"
      />
      <div v-if="emailLoading" style="min-height: 100px;" v-loading="emailLoading" element-loading-text="Loading..." />
      <el-row v-if="!selectedPos && !selectedPos.length" align="middle" justify="center" class="nodata-heading">
        No data available
      </el-row>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="sendEmailVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      @close="closeSendEmailModal">
      <el-row type="flex" align="middle" justify="end" style="border-bottom: 1px solid lightgrey;">
        <HeaderInfoText :colspan="12" title="Send Email" />
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button type="primary" @click="cancelSendEmail" style="margin: 0 15px;">Cancel</el-button>
            <el-button type="primary" @click="sendEmail" style="margin: 0 15px;">Send Email</el-button>
          </el-row>
        </el-col>
      </el-row>
      <nacha-po-conf-list
        v-if="sendEmailVisible && selectedPos"
        name="nacha_po_conf_list"
        ref="nacha_po_conf_list"
        :allow-edit="true"
        :allow-notify="false"
        :width="width"
        :height="height"
        :row-data="selectedPos"
        @onSelect="handleSelectedConf"
        @updateCCMail="handleCellUpdate"
      />
      <el-row v-if="!selectedPos && !selectedPos.length" align="middle" justify="center" class="nodata-heading">
        No data available
      </el-row>
    </el-dialog>
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew1.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import CustomerVendorForm from '@/components/FormComponents/CustomerVendorForm.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import ProscanFileViewer from '@/components/RouteComponents/Proscan/ProscanFileViewer.vue'
  import { proscanFileViewMixins } from '@/Mixins/ProscanFileView'
  import { isTransactionBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { buildPeriodOptionsList } from '@/utils/helpers/DataEntryViews/BuildPeriodOptionsList'
  import { tabThruModalButtons } from '@/utils/helpers/KeyNavHelper'
  import { formatDistributionLineMoneyFields } from '@/utils/helpers/DataEntryViews/FormatMoneyFields'
  import { trackHeaderChanges, trackDistributionChanges } from '@/utils/helpers/DataEntryViews/TrackChanges'
  import { transactionEditViewMixins } from '@/Mixins/TransactionEditViews'
  import { poFieldsMixin } from '@/Mixins/PoFields'
  import { vendorMixins } from '@/Mixins/VendorMixins'
  import { reportMixins } from '@/Mixins/Reports'
  import sortLines from '@/utils/helpers/DataEntryViews/SortLines'
  import LinesLoading from '@/components/LinesLoading.vue'
  import FindOrFetchBatchAndPeriod from '@/utils/helpers/DataEntryViews/FindOrFetchBatchAndPeriod'
  import { notify } from '@/utils/helpers/Notify'
  import store from '@/store/store'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import DocumentDialog from '@/components/DocumentDialog.vue'
  import NachaPoConfList from '@/components/SigmaClientNew/NachaPoConfList.vue'
  import { errMsgRefresh } from '@/utils/supportErrMsg'
  import { getPoLinesToRelieve, loadInitialData } from '@/utils/helpers/DataEntryViews/BeforeRouteEnterHelpers'
  import { formatAmount } from '@/utils/helpers/AmountFormatter'

  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      CustomerVendorForm,
      HeaderInfoText,
      DataEntryButtons,
      ProscanFileViewer,
      LinesLoading,
      DocumentDialog,
      NachaPoConfList
    },
    mixins: [ transactionEditViewMixins, poFieldsMixin, vendorMixins, reportMixins, proscanFileViewMixins ],
    data () {
      const { getPoById, getPoLineById, getBatchById, getVendorById, getJasperHost, checkIfUserHasRequiredPermissions } = this.$store.getters
      const c = getPoById(this.$route.params.id)
      let lines = c.lines.map((v, i) => {
        const line = getPoLineById(v)
        return { line_number: line.line_number || i + 1, form: Object.assign({}, line) }
      })
      lines = this.buildOriginalPoLines(lines)
      return {
        modelId: null,
        transactionType: { name: 'po', path: '/pos/', prettyName: 'Purchase Order' },
        originalHeader: c,
        originalLines: lines,
        reopeningPo: false,
        form: {
          batch: { label: c.batch ? getBatchById(c.batch).name : '', value: c.batch || '' },
          vendor: { label: c.vendor ? getVendorById(c.vendor).name : '', value: c.vendor || '' },
          period: c.period,
          state: c.state || '',
          description: c.description || '',
          number: c.number || '',
          amount_decimal: c.amount_decimal || '',
          date: c.date || '',
          effective_date: c.effective_date || '',
          expiration: c.expiration || '',
          status: c.status
        },
        headerDeltas: {},
        lineDeltas: {},
        lines,
        nonAsyncSuggestions: {
          active: '',
          period: [{ label: 'Next', value: '' }]
        },
        loadingOptions: false,
        dialogVisible: false,
        readOnly: !['DRAFT', 'OPEN', 'AUDITED', 'POSTED'].includes(c.status) || (!checkIfUserHasRequiredPermissions(['entry.view_purchaseorder', 'entry.add_purchaseorder']) && ['DRAFT', 'OPEN', 'AUDITED'].includes(c.status)) || (!checkIfUserHasRequiredPermissions(['entry.view_purchaseorder', 'entry.add_purchaseorder', 'entry.post_purchaseorder']) && ['POSTED'].includes(c.status)),
        closeLineModalVisible: false,
        closePoModalVisible: false,
        closingPo: false,
        deletePoModalVisible: false,
        deletingPo: false,
        currentLineToClose: '',
        closedPoLineToUpdate: null,
        changesWereSaved: false,
        transactionIsBalanced: false,
        amountHasChanged: false,
        statusToRestore: '',
        altRoute: null,
        ready: false,
        isSaving: false,
        currentVendorSelection: '',
        closingLine: false,
        dropzoneVisible: false,
        poCanBeDeleted: false,
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportName: 'po_v1_report'
        },
        companyAddress: null,
        sendEmailVisible: false,
        selectedPos: [],
        ccMail: {},
        emailLoading: false,
        disablePrevButton: true,
        disableNextButton: true,
        loadingPrev: false,
        loadingNext: false,
        paginationData: []
      }
    },
    methods: {
    /**
     * Shows a confirmation dialog when a user tries to post the transaction
     * @return {Promise<void>}
     */
      async showConfirmationDialog () {
        try {
          await this.$confirm('Do you wish to post this transaction?', 'Warning', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
          this.handleSubmit(true, { status: 'POSTED' })
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * Updates modelId prop passed to customer create/edit modal
       */
      updateVendorModelId (id) {
        this.modelId = id
      },
      /**
       * Function that allows the user to directly add a new transaction from
       * the edit view for a given transaction type. Assuming that this
       * function is only used with the + buttons in transaction edit views,
       * it parses the route name, changes it to a valid transaction create view route
       * name, and starts the navigation process.
       */
      addNew () {
        const newRoute = this.$route.name.replace('Edit', 'New')
        if (this.form.batch && this.form.batch.value) {
          this.$router.push({ name: newRoute, query: { batch: this.form.batch.value } })
        } else {
          this.$router.push({ name: newRoute })
        }
      },
      /**
       * Generates an alternate route depending on whether to the to argument contains a route
       * name and if it contains a query.
       * @param to
       * @return {Object}
       */
      generateAltRoute (to) {
        if (to && to.name && to.query) return { name: to.name, query: to.query }
        return { name: to.name }
      },
      /**
       * Resets PO line to close
       */
      resetClosedPoLineToUpdate () {
        this.closedPoLineToUpdate = null
      },
      /**
       * Formats dollar amounts for a specific distribution line field
       * @param coordinates
       */
      formatLineMoneyField (coordinates) {
        formatDistributionLineMoneyFields(this, coordinates)
      },
      /**
       * Set the id of the line to close, then show confirmation modal
       * @param id
       */
      handleCloseLine (id) {
        this.currentLineToClose = id
        this.handleCloseLineModalVisible(true)
      },
      /**
       * Governs whether the line closing modal is visible
       */
      handleCloseLineModalVisible (visibleState) {
        this.closeLineModalVisible = visibleState
      },
      /**
       * Gets the id of the line to close, then closes it
       */
      async closeLine () {
        try {
          this.ready = true
          this.closingLine = true
          const lineUpdateResp = await this.$store.dispatch('updateLine', {
            type: 'po',
            id: this.currentLineToClose,
            line: { type: 'CLOSED', source_type: 'Manual' }
          })
          if (!(lineUpdateResp && lineUpdateResp.id)) {
            throw new Error('Unable to update line status to CLOSED.')
          }
          const { id } = this.$route.params
          const poUpdateResp = await this.$store.dispatch('fetchPosWithQuery', { // Refresh PO, including lines. This should return the new offset line created by the API
            query: { id },
            storeLines: true
          })
          if (!(poUpdateResp && poUpdateResp.count)) {
            throw new Error('This line was successfully closed, but there was an error refreshing the PO and associated lines.')
          }
          const poLines = this.getPoById(id).lines.map(v => this.getPoLineById(v))
          this.lines = this.buildOriginalPoLines(poLines)
        } catch (e) {
          const line = this.lines.find(line => line.form.id === this.currentLineToClose)
          this.$notify({ title: `Error closing line ${line.line_number}`, message: e.message + errMsgRefresh, type: 'error' })
          console.log(e)
        } finally {
          this.handleCloseLineModalVisible(false)
          this.closingLine = false
          this.closedPoLineToUpdate = this.currentLineToClose
          this.currentLineToClose = ''
        }
      },
      /**
       * Gets the id of the line to close, then closes it
       */
      async handleReopenLine (id) {
        this.currentLineToClose = id
        try {
          this.ready = true
          this.closingLine = true
          const lineUpdateResp = await this.$store.dispatch('updateLine', {
            type: 'po',
            id: this.currentLineToClose,
            line: { type: 'OPEN', source_type: 'Manual' }
          })
          if (!(lineUpdateResp && lineUpdateResp.id)) {
            throw new Error('Unable to update line to REOPEN.')
          }
          const { id } = this.$route.params
          const poUpdateResp = await this.$store.dispatch('fetchPosWithQuery', { // Refresh PO, including lines. This should return the new offset line created by the API
            query: { id },
            storeLines: true
          })
          if (!(poUpdateResp && poUpdateResp.count)) {
            throw new Error('This line was successfully reopened, but there was an error refreshing the PO and associated lines.')
          }
          const poLines = this.getPoById(id).lines.map(v => this.getPoLineById(v))
          this.lines = this.buildOriginalPoLines(poLines)
        } catch (e) {
          const line = this.lines.find(line => line.form.id === this.currentLineToClose)
          this.$notify({ title: `Error reopening line ${line.line_number}`, message: e.message + errMsgRefresh, type: 'error' })
          console.log(e)
        } finally {
          this.handleCloseLineModalVisible(false)
          this.closingLine = false
          this.closedPoLineToUpdate = this.currentLineToClose
          this.currentLineToClose = ''
        }
      },
      /**
       * Cancels closing a line
       */
      cancelCloseLine () {
        this.currentLineToClose = ''
        this.handleCloseLineModalVisible(false)
      },
      /**
       * Governs whether the "Close all lines" modal is visible
       */
      handleClosePoModalVisible (visibleState) {
        this.closePoModalVisible = visibleState
      },
      /**
       * Reopen the current PO
       */
      async reOpenPO () {
        try {
          this.ready = true
          this.reopeningPo = true
          const { id } = this.$route.params
          const resp = await this.$store.dispatch('updatePo', { id: `${id}/reopen_po`, data: { status: 'OPEN', source_type: 'Manual' } })
          if (!(resp && resp.message && resp.message.includes('Updated the data'))) {
            throw new Error(`Error updating status to OPEN for PO ${id}.`)
          }
          await this.$store.dispatch('fetchPosWithQuery', { query: { id }, storeLines: true })
          this.checkPoCanDelete()
        } catch (e) {
          this.$notify({ title: 'Error re-opening PO', message: e.message + errMsgRefresh, type: 'error' })
          console.log(e)
        } finally {
          this.reopeningPo = false
          this.handleClosePoModalVisible(false)
        }
      },
      /**
       * Closes the current PO
       */
      async closePo () {
        try {
          this.ready = true
          this.closingPo = true
          const { id } = this.$route.params
          const resp = await this.$store.dispatch('updatePo', { id, data: { status: 'CLOSED', source_type: 'Manual' } })
          if (!(resp && resp.id)) {
            throw new Error(`Error updating status to CLOSED for PO ${id}.`)
          }
        } catch (e) {
          this.$notify({ title: 'Error closing PO', message: e.message + errMsgRefresh, type: 'error' })
          console.log(e)
        } finally {
          this.closingPo = false
          this.handleClosePoModalVisible(false)
        }
      },
      /**
       * Cancels closing all lines and hides the 'Close all lines' modal
       */
      cancelClosePo () {
        this.closingPo = false
        this.currentLineToClose = ''
        this.closedPoLineToUpdate = null
        this.handleClosePoModalVisible(false)
      },
      /**
       * Governs whether the "Delete PO" modal is visible
       */
      handleDeletePoModalVisible (visibleState) {
        this.deletePoModalVisible = visibleState
      },
      /**
       * Deletes the current PO Permanently
       */
      async deletePo () {
        try {
          this.ready = true
          this.deletingPo = true
          const { id } = this.$route.params
          const resp = await this.$store.dispatch('checkPoCanDelete', { id })
          if (!(resp && resp.data)) {
            throw new Error(`Error deleting a PO ${id}.`)
          }
          // Can delete PO
          if (resp.all_conditions_met) {
            const response = await this.$store.dispatch('deletePo', { id })
            this.$notify({ title: 'Success', message: response.data, type: 'success' })
            this.deletingPo = false
            this.handleDeletePoModalVisible(false)
            this.$router.push({ name: 'POs' })
          } else {
            if (!resp.data.po_status) {
              this.$notify({ title: 'Error deleting PO', message: 'PO transaction Status', type: 'error' })
            } else if (!resp.data.po_period_status) {
              this.$notify({ title: 'Error deleting PO', message: 'PO transaction is in a Closed period', type: 'error' })
            } else if (!resp.data.po_approval_status) {
              this.$notify({ title: 'Error deleting PO', message: 'PO transaction has approval history', type: 'error' })
            } else if (!resp.data.po_lines_status) {
              this.$notify({ title: 'Error deleting PO', message: 'PO transaction is linked to other transaction', type: 'error' })
            } else if (!resp.data.po_open_lines_status) {
              this.$notify({ title: 'Error deleting PO', message: 'All PO transaction lines should be Open', type: 'error' })
            }
            this.deletingPo = false
            this.handleDeletePoModalVisible(false)
          }
        } catch (e) {
          this.$notify({ title: 'Error deleting PO', message: e.message + errMsgRefresh, type: 'error' })
          this.deletingPo = false
          this.handleDeletePoModalVisible(false)
          console.log(e)
        }
      },
      /**
       * Cancels deleting PO and hides the 'Delete' modal
       */
      cancelDeletePo () {
        this.deletingPo = false
        this.handleDeletePoModalVisible(false)
      },
      /**
       * Governs what happens when the 'Back' button is clicked
       */
      goBack (reset = false) {
        if (reset) this.hasBeenChanged = false
        this.ready = false
        if (this.altRoute && Object.keys(this.altRoute).length) {
          this.$router.push(this.altRoute)
        } else {
          this.$router.push({ name: 'POs' })
        }
      },
      /**
       * Submits the form.
       * @param saveOnly Enables or disables any navigation that should occur after the transaction is saved
       * @param explicitDeltas Specifies hard-coded deltas that need to be set, such as status
       * @param reportToRun Specifies type of report to run once saved. Can be 'audit' or 'posting'
       */
      handleSubmit (saveOnly, explicitDeltas = null, reportToRun = null) {
        if (this.dialogVisible) this.handleDialogVisible(false)   // Close any open dialog boxes
        this.isValidPO()
        let removedLines = this.removeDeletedLines()
        const { headerDeltas, lineDeltas } = this
        if (explicitDeltas) this.headerDeltas = Object.assign(headerDeltas, explicitDeltas)
        const hDeltaCount = Object.keys(headerDeltas).length
        const lDeltaCount = Object.keys(lineDeltas).length
        const stripTypeProperty = () => {
          this.lines = this.lines.map(line => {
            if (!line.form.id && line.form.hasOwnProperty('type')) {
              delete line.form.type
            }
            return line
          })
        }
        if (hDeltaCount || lDeltaCount) {
          this.isSaving = true
          stripTypeProperty()
          this.saveTransactionChanges('Po', saveOnly, reportToRun)
        } else {
          isTransactionBalanced(this)
          this.checkForChanges()
          if (removedLines.length) {
            removedLines.forEach(lineNum => this.$refs['distribution-lines'].removeLine(lineNum))
          }
        }
      },
      /**
       * Updates the distribution lines
       * @param lines   Array of distribution line objects
       */
      updateLines (lines) {
        this.lines = lines
        this.linesChanged()
      },
      /**
       * Updates the header form
       * @param form  The header form object
       */
      updateForm (form, changedField = null) {
        this.form = { ...form }
        if (this.form.vendor.value) {
          this.handleVendorChange(form)
          this.currentVendorSelection = this.form.vendor.value
        } else {
          this.currentVendorSelection = ''
        }
        if (changedField === 'number' || changedField === 'vendor') {
          this.checkIfTrxExists()
        }
        this.headerDeltas = trackHeaderChanges(this.form, this.originalHeader)
        this.checkForChanges()
      },
      openExistingTrx (id) {
        if (this.trxAlreadyExistsMsg) {
          this.trxAlreadyExistsMsg.close()
        }
        if (id) {
          this.isSaveable = false
          return this.$router.push({ name: 'EditPo', params: { id } })
        }
      },
      async checkIfTrxExists () {
        clearTimeout(this.vendorNumberCheckTimeout)
        const { number } = this.form
        const data = { conditionsMet: false, action: null }
  
        data.conditionsMet = !!number
        data.action = async () => this.$store.dispatch('fetchPosWithQuery', { number })

        if (data.conditionsMet && typeof data.action === 'function') {
          try {
            const resp = await data.action()
            if (!resp) {
              throw new Error('No response')
            }
            if (resp.hasOwnProperty('count') && resp.count) {
              const id = Object.values(resp.entities[`pos`])[0].id
              if (id.toString() === this.$route.params.id.toString()) {
                this.trxAlreadyExists = false
                if (this.trxAlreadyExistsMsg) this.trxAlreadyExistsMsg.close()
                return
              }
              this.trxAlreadyExists = true
              const h = this.$createElement
              this.trxAlreadyExistsMsg = this.$message({
                message: h('p', null, [
                  h('span', null, `A transaction with this number already exists! `),
                  h('button', { on: { click: () => this.openExistingTrx(id) } }, `Discard current & view existing PO`)
                ]),
                type: 'warning',
                duration: 0,
                showClose: true
              })
            } else {
              this.trxAlreadyExists = false
              if (this.trxAlreadyExistsMsg) this.trxAlreadyExistsMsg.close()
            }
          } catch (e) {
            console.log(e)
          }
        }
      },
      async handleVendorChange (form) {
        if (form.vendor.value) {
          let vendorData = this.getVendorById(form.vendor.value)
          if (!vendorData.id) {
            await this.$store.dispatch('fetchVendorById', form.vendor.value)
            vendorData = this.getVendorById(form.vendor.value)
            if (vendorData && vendorData.address_selected && vendorData.address_selected.id && vendorData.address_selected.city) {
              await this.$store.dispatch('fetchCitiesWithQuery', { id__in: [vendorData.address_selected.city], page_size: 1 })
            }
          } else {
            if (vendorData && vendorData.address_selected && vendorData.address_selected.id && vendorData.address_selected.city && typeof vendorData.address_selected.city === 'number') {
              await this.$store.dispatch('fetchCitiesWithQuery', { id__in: [vendorData.address_selected.city], page_size: 1 })
            }
          }
        }
      },
      /**
       * Called whenever this.updateLines is called. Checks whether the transaction is balanced, and tracks
       * distribution changes. Finally, calls this.checkForChanges.
       * TODO: shouldn't you call this.checkForChanges first and perform the other logic only if it retuns true?
       */
      linesChanged () {
        this.lineDeltas = trackDistributionChanges(this.lines, this.originalLines)
        this.checkForChanges()
      },
      /**
       * Sets read-only mode
       */
      toggleReadOnly () {
        this.readOnly = !this.readOnly
      },
      handleDialogVisible (visible) {
        this.dialogVisible = visible
        tabThruModalButtons(visible ? 'exit-modal-btn' : null)
      },
      /**
       * Checks whether this transaction has been changed
       */
      checkForChanges () {
        this.hasBeenChanged = !!(Object.keys(this.headerDeltas).length + Object.keys(this.lineDeltas).length)
      },
      checkIfOpenable () {
        const { transactionIsBalanced, lines } = this
        this.isOpenable = (transactionIsBalanced) && (lines && lines.length)
      },
      handleDropdownClick (c) {
        const { handleSubmit } = this
        switch (c) {
          case '1':
            this.originalHeader.status === 'DRAFT' && this.transactionIsBalanced
              ? handleSubmit(true, { status: 'POSTED' })  // Save and post if draft and balanced
              : handleSubmit(true)                        // Save only
            break
          case '2':   // Save & keep working (if transaction is balanced and status is not draft)
            handleSubmit(true, { status: 'OPEN' })
            break
          case '3':   // Save & audit
            handleSubmit(true, { status: 'AUDITED' })
            break
          case '4':   // Save & post
            handleSubmit(true, { status: 'POSTED' })
        }
      },
      cancelExit () {
        this.altRoute = null
        this.handleDialogVisible(false)
      },
      updateHeaderStatusField () {
        let tmp = Object.assign({}, this.form)
        tmp.status = this.originalHeader.status
        this.form = Object.assign({}, tmp)
      },
      async convertToAP () {
        try {
          const { id } = this.$route.params
          const resp = await this.$store.dispatch('convertToAP', id)
          if (!(resp && resp.ok)) {
            throw new Error(`Error converting to PO ${id}.`)
          } else {
            if (resp.body.converted_to_ap) {
              this.originalHeader.converted_to_ap = true
              this.$notify({ title: 'Success', message: resp.body.message, type: 'success' })
            } else {
              this.originalHeader.converted_to_ap = false
              this.$notify({ title: 'Conversion Failed', message: resp.body.message, type: 'error' })
            }
          }
        } catch (e) {
          this.$notify({ title: 'Error converting to PO', message: e.message + errMsgRefresh, type: 'error' })
        }
      },
      // Function to setup a dropzone instance
      setupDropzoneOptions () {
        let instance = this.$store.getters.getActiveInstance
        let instanceUrl = (instance.url.endsWith('/') ? instance.url.slice(0, -1) : instance.url)
        let path = this.$route.path.includes('pettycash') ? `/pcs/${this.$route.params.id}` : this.$route.path
        return {
          instanceUrl: instanceUrl,
          url: instanceUrl + path + '/files',
          headers: '',
          signingUrl: instanceUrl + path + '/files',
          signingHeaders: { 'Authorization': 'Bearer ' + instance.token },
          acceptedFiles: '.txt,.pdf,.jpg,.png,.tif,.tiff,.doc,.docx,.xls,.xlsx',
          autoProcessQueue: false,
          maxFileSize: 8,
          uploadMultiple: false,
          parallelUploads: 1
        }
      },
      getSignedFile () {
      },
      dzSuccess () {
        this.numberOfFiles = 1
      },
      dzFailure () {
        console.log('Success! just kidding')
      },
      dzRemove () {
        this.numberOfFiles = -1
      },
      getCompanyCity (companyId) {
        return new Promise((resolve, reject) => {
          const company = this.batchAttributes.company
          this.companyAddress = this.getAddressById(company.address_id)
          if (!isNaN(this.companyAddress.city)) {
            this.$store.dispatch('fetchCitiesWithQuery', { id__in: [this.companyAddress.city], page_size: 1 })
              .then((res) => {
                if (res.count) {
                  const city = Object.values(res.entities.cities).find((v) => v.id === this.companyAddress.city)
                  if (city && city.name) {
                    this.companyAddress.city = city.name
                    resolve(true)
                  }
                }
              })
          } else {
            resolve(true)
          }
        })
      },
      otherActions (action) {
        switch (action) {
          case 'printpo':
            this.getCompanyCity()
              .then(() => {
                this.printPo()
              })
            break
          case 'emailpo':
            this.emailPo()
            break
          case 'uploadDocument':
            this.dropzoneVisible = true
            break
        }
      },
      closeSendEmailModal () {
        this.sendEmailVisible = false
        this.ccMail = []
      },
      async emailPo (e) {
        this.emailLoading = true
        this.sendEmailVisible = true
        this.ccMail = []
        const po = this.getPoById(this.$route.params.id)
        const company = this.batchAttributes.company
        this.selectedPos = [
          {
            attributes: {
              po_id: po.id,
              vendor_id: po.vendor,
              vendor_name: po.vendor_data.name,
              email: po.vendor_data.email,
              amount_decimal: po.amount_decimal,
              number: po.number,
              description: po.description,
              file_attachment: true,
              company_email: company.email,
              cc_mail: ''
            }
          }
        ]
        this.emailLoading = false
      },
      async sendEmail () {
        try {
          this.emailLoading = true
          let posSelected = []
          let selectedPosWithEmail = []
          let selectedPosWithOutEmail = []
          if (this.selectedPos.length) {
            selectedPosWithEmail = this.selectedPos.filter((obj) => { return obj.attributes.email })
            selectedPosWithOutEmail = this.selectedPos.filter((obj) => { return !obj.attributes.email })
            selectedPosWithEmail.forEach((mail) => {
              let item = {
                id: mail.attributes.po_id,
                file_attachment: mail.attributes.file_attachment,
                cc_mail: false
              }
              if (mail.attributes.cc_mail) {
                item.cc_mail = true
              }
              posSelected.push(item)
            })

            if (posSelected.length) {
              const newPayload = Object.assign({}, { purchase_order: posSelected })
              const resp = await this.$store.dispatch('notifyPos', newPayload)
              if (resp && resp.success.vendors.length) {
                notify(this, 'success', 'Email sent to ' + resp.success.vendors.map((vendor) => vendor.name).join(', '), 10)
                this.emailLoading = false
              }
            }

            // notify if vendors do not have emails
            if (selectedPosWithOutEmail.length) {
              notify(this, 'error', 'Unable to send email to ' + selectedPosWithOutEmail.map((po) => po.attributes.vendor_name).join(', '), 100)
              this.emailLoading = false
            }
          } else {
            // this.emailLoading = false
            // notify(this, 'error', 'Error sent email')
            // return false
          }
        } catch (e) {
          console.log(e)
          this.emailLoading = false
          notify(this, 'error', 'Error sent email')
          return e
        }
      },
      cancelSendEmail () {
        this.sendEmailVisible = false
        this.ccMail = []
      },
      handleSelectedConf (selection, index) {
        this.selectedPos[index].attributes.cc_mail = selection
        this.selectedPos[index].attributes.file_attachment = selection
      },
      handleUpdateCCMail (param, index) {
        this.selectedPos[index].attributes.cc_mail = param.newValue
      },
      handleUpdateFileAttachment (param, index) {
        this.selectedPos[index].attributes.file_attachment = param.newValue
      },
      printPo () {
        this.reportNotif = this.$message({
          message: 'Building report. Please wait...',
          duration: 0
        })
        this.poReport()
          .then(json => {
            if (!json.report.company_city && this.companyAddress.city) {
              json.report.company_city = isNaN(this.companyAddress.city) ? this.companyAddress.city : this.getCityById(this.companyAddress.city).name
            }
            return this.getJsonUrl(json)
          })
          .then(resJsonUrl => {
            // PDF version of the report
            let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
            return this.getReportUrl(report)
          })
          .then(reportUrl => {
            this.reportNotif.close()
            this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
          })
          .catch(error => {
            this.reportNotif.close()
            console.log(error)
          })
      },
      poReport () {
        return new Promise((resolve, reject) => {
          const po = this.getPoById(this.$route.params.id)
          let poLines = []
          const poTransactionLines = this.getPoLinesByTransactionId(this.$route.params.id)
          const company = this.batchAttributes.company

          Object.values(poTransactionLines).forEach((v, i) => {
            poLines.push({
              line_id: i + 1,
              amount_decimal: v.amount_decimal,
              description: v.description,
              account_id: v.account_code + '-' + v.account_name,
              series_id: v.series ? this.getSeriesById(v.series).code : '',
              location_id: v.location ? this.getLocationById(v.location).code : '',
              set_id: v.set ? this.getSetById(v.set).code : '',
              tax_code_id: v.tax_code ? this.getTaxcodeById(v.tax_code).code : '',
              free_field_1_id: v.free_field_1 ? this.getFreefieldById(v.free_field_1).code : '',
              free_field_2_id: v.free_field_2 ? this.getFreefieldById(v.free_field_2).code : '',
              free_field_3_id: v.free_field_3 ? this.getFreefieldById(v.free_field_3).code : '',
              free_field_4_id: v.free_field_4 ? this.getFreefieldById(v.free_field_4).code : '',
              third_party_vendor_id: v.third_party_vendor ? this.getVendorById(v.third_party_vendor).name : ''
            })
          })
          let vendorAddress = this.getAddressById(po.vendor_data.address_selected_id)
          let json = {
            report: {
              company_name: company.name,
              company_address1: this.companyAddress && this.companyAddress.line1 ? this.companyAddress.line1 : '',
              company_address2: this.companyAddress && this.companyAddress.line2 ? this.companyAddress.line2 : '',
              company_city: isNaN(this.companyAddress.city) ? this.companyAddress.city : this.getCityById(this.companyAddress.city).name,
              company_state: this.companyAddress && this.companyAddress.state ? this.getStateById(this.companyAddress.state).name : '',
              company_postal: this.companyAddress.postal || '',
              company_phone: company.phone || '',
              po_number: po.number || '',
              po_date: po.date,
              po_description: po.description,
              po_amount: Number(po.amount_decimal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              po_department: '',
              po_batch: po.batch,
              po_transaction: po.id,
              po_status: po.status,
              vendor_name: po.vendor_data.name,
              vendor_address1: vendorAddress && vendorAddress.line1 ? vendorAddress.line1 : '',
              vendor_address2: vendorAddress && vendorAddress.line2 ? vendorAddress.line2 : '',
              vendor_city: isNaN(vendorAddress.city) ? vendorAddress.city : this.getCityById(vendorAddress.city).name,
              vendor_state: vendorAddress && vendorAddress.state ? this.getStateById(vendorAddress.state).name : '',
              vendor_postal: vendorAddress.postal || '',
              vendor_tax_id: po.vendor_data.tax_id || '',
              po_lines: poLines.sort((a, b) => a.line_id - b.line_id)
            }
          }
          resolve(json)
        })
      },
      async checkPoCanDelete (selectedPeriod, currentPeriod) {
        if (['DRAFT', 'OPEN', 'AUDITED'].includes(this.originalHeader.status)) {
          if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
            this.poCanBeDeleted = false
          } else {
            this.poCanBeDeleted = true
          }
        } else if (this.originalHeader.status === 'POSTED') {
          if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
            this.poCanBeDeleted = false
          } else {
            const { id } = this.$route.params
            const resp = await this.$store.dispatch('checkPoCanDelete', { id })
            if (!(resp && resp.data)) {
              this.poCanBeDeleted = false
            } else {
              this.poCanBeDeleted = resp.all_conditions_met
            }
          }
        } else {
          this.poCanBeDeleted = false
        }
      },
      async pageNavigation (type) {
        // Get the index of the current AP ( Current route id)
        let transactionIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
        let prevAndNextId = parseInt(this.$route.params.id)
        if (transactionIndex >= 0) {
          // Check Index is greater than zero and type is 'next'
          if (type === 'next') {
            this.loadingNext = true
            // Check upcoming Record is exist or not
            let checkNextId = this.paginationData[transactionIndex + 1]
            if (!checkNextId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkNextId).length) {
              prevAndNextId = checkNextId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'next' button
            this.disableNextButton = !this.paginationData[transactionIndex + 2]
          } else if (type === 'prev') {
            this.loadingPrev = true
            // Check upcoming Record is exist or not
            let checkPrevId = this.paginationData[transactionIndex - 1]
            if (!checkPrevId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkPrevId).length) {
              prevAndNextId = checkPrevId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'previous' button
            this.disablePrevButton = !this.paginationData[transactionIndex - 2]
          }
        }
        // Refresh the data without reloading the page
        this.refreshPage(prevAndNextId)
      },
      // Its copy of 'beforeRouteEnter': To refresh the data
      async refreshPage (routeId) {
        const { getPoById } = store.getters
        try {
          const resp = await store.dispatch('fetchPosWithQuery', { query: { id: routeId }, storeLines: true })
          let promises = [store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' })]
          if (resp && resp.entities) {
            const deps = await store.dispatch('findDependencies', resp.entities) || []
            promises = [...promises, ...deps]
          }
          await Promise.all(promises)
          const po = getPoById(routeId)
          await getPoLinesToRelieve(po.id, 'po')
          promises = [...FindOrFetchBatchAndPeriod(store, po)]
          if (promises.length) {
            await Promise.all(promises)
          }
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
        } catch (e) {
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
          console.log(e)
        }
      },
      async customCreated () {
        // To Prepare Query params to pass to the API
        let selectedStatuses = ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'VOIDED', 'CLOSED']
        let paginationQuery = { status__in: selectedStatuses }
        // Fetch 'paginationQuery' data is exist or not from the session storage
        let sessionStorageQuery = sessionStorage.getItem('paginationQuery')
        // Add pagination query in the session storage
        if (sessionStorageQuery) paginationQuery = JSON.parse(sessionStorageQuery)
        // Fetch 'paginationInfo' data is exist or not from the session storage
        let validatePaginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        let entities = []
        let response = []
        try {
          // API to get the results based on the Query
          entities = await store.dispatch('fetchPosWithQuery', paginationQuery)
          response = this.$store.getters.getPos || []

          // Check and assign the response data
          if (!validatePaginationData) {
            validatePaginationData = response.sort((a, b) => b.id - a.id)
          }
          // Check unique data is exist or not
          if (validatePaginationData) sessionStorage.setItem('paginationInfo', JSON.stringify(validatePaginationData))
          else sessionStorage.setItem('paginationInfo', JSON.stringify(response.sort((a, b) => b.id - a.id)))
          // Assign pagination info to the paginationData
          this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        } catch (error) {
          console.error()
        }
        this.disablePrevButton = false
        this.disableNextButton = false
        if (this.paginationData && this.paginationData.length > 0) {
          // To get the current index
          let getIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
          // Check index value is zero then disable prev button
          if (getIndex === 0) {
            if (entities) {
              if (!entities.previous) {
                this.disablePrevButton = true
              }
              if (!entities.next && getIndex === this.paginationData.length - 1) {
                this.disableNextButton = true
              }
              if (entities.previous) {
                paginationQuery['page'] = Number(paginationQuery['page']) - 1
                try {
                  // API to get the results based on the Quey param
                  entities = await store.dispatch('fetchPosWithQuery', paginationQuery)
                  response = this.$store.getters.getPos || []
                  let totalPaginationData = [...validatePaginationData, ...response]
                  // Update 'paginationInfo' data in the session storage
                  sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                  // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                  this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                  sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
                } catch (error) {
                  console.error()
                }
              }
            }
          } else if (getIndex === this.paginationData.length - 1) {
            // Check next available page is exist or not
            if (!entities || !entities.next) {
              this.disableNextButton = true
            } else {
              paginationQuery['page'] = Number(paginationQuery['page']) + 1
              try {
                // API to get the results based on the Quey param
                entities = await store.dispatch('fetchPosWithQuery', paginationQuery)
                response = this.$store.getters.getPos || []
                let totalPaginationData = [...validatePaginationData, ...response]
                // Update 'paginationInfo' data in the session storage
                sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
              } catch (error) {
                console.error()
              }
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        getPos: 'getPos',
        getPoById: 'getPoById',
        getLineById: 'getLineById',
        getPoLineById: 'getPoLineById',
        getPoLinesByTransactionId: 'getPoLinesByTransactionId',
        getPoLines: 'getPoLines',
        getVendorById: 'getVendorById',
        getAccountById: 'getAccountById',
        getSeriesById: 'getSeriesById',
        getLocationById: 'getLocationById',
        getSetById: 'getSetById',
        getPeriodById: 'getPeriodById',
        currentPeriod: 'getCurrentPeriod',
        getStateById: 'getStateById',
        getCityById: 'getCityById',
        getAddressById: 'getAddressById',
        getCompanyById: 'getCompanyById',
        getFreefieldById: 'getFreefieldById',
        getTaxcodeById: 'getTaxcodeById',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions',
        checkIfUserHasAnyOfThePermissions: 'checkIfUserHasAnyOfThePermissions'
      }),
      width () {
        // Reducing by 3 % to handle sigma-frontend navbar
        return '100%'
      },
      height () {
        // Reducing by 3 % to handle sigma-frontend navbar
        return window.innerHeight * 0.63 + 'px'
      },
      selectedPeriod () {
        const po = this.getPoById(this.$route.params.id)
        if (po && po.period && this.getPeriodById(po.period).id) {
          return this.getPeriodById(po.period)
        }
      },
      states () {
        return this.$store.getters.getAllStates.map(v => ({ label: v.name, value: v.id }))
      },
      hasCreateApPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_accountspayable', 'entry.add_accountspayable'])
      },
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_purchaseorder', 'entry.add_purchaseorder'])
      },
      hasPostPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_purchaseorder']) && this.checkIfUserHasAnyOfThePermissions(['entry.post_purchaseorder', 'auth.post_transactions'])
      },
      hasEditPermission () {
        if (['POSTED', 'CLOSED'].includes(this.originalHeader.status)) return this.hasPostPermission
        else return this.hasCreatePermission
      },
      hasDeletePermission () {
        return this.hasCreatePermission && this.checkIfUserHasRequiredPermissions(['entry.delete_purchaseorder'])
      },
      hasCreateBatchPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_batch', 'entry.add_batch'])
      },
      hasReadPermission () {
        let readPermission = ['entry.view_purchaseorder']
        return this.checkIfUserHasRequiredPermissions(readPermission)
      },
      hasPermission () {
        return {
          read: this.hasReadPermission,
          create: this.hasCreatePermission,
          edit: this.hasEditPermission,
          delete: this.hasDeletePermission,
          post: this.hasPostPermission,
          createAP: this.hasCreateApPermission
        }
      },
      fields () {
        const c = this.getPoById(this.$route.params.id)
        const currency = this.$store.getters.getCurrencyByBatchId(this.form.batch.value)
        let fields = {
          vendor: {
            inputFields: [
              {
                name: 'vendor',
                label: 'Vendor',
                dataType: 'string',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'vendors', params: { active: 'True' } },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a vendor',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                addBtn: !['CLOSED', 'VOIDED'].includes(c.status) && this.userCanCreateVendor
              }
            ],
            displayFields: [
              {
                name: 'vendor',
                label: 'Address',
                value: this.vendorAddressLine || ''
              },
              {
                name: 'vendor',
                label: 'Type',
                value: this.form.vendor.value ? this.getVendorById(this.form.vendor.value).entity_type : ''
              }
            ]
          },
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'batches' },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a batch',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                addBtn: !['CLOSED', 'VOIDED'].includes(c.status) && this.hasCreateBatchPermission
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          transactionData: {
            inputFields: [
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                msg: 'Please provide a description',
                min: 3,
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'number',
                label: 'Number',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'amount_decimal',
                label: 'Amount',
                dataType: 'string',
                fieldType: 'money',
                required: true,
                isMoney: true,
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                msg: 'Please specify a date',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'effective_date',
                label: 'Effective date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                fieldType: 'date',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'expiration',
                label: 'Expiration',
                dataType: 'string',
                fieldType: 'date',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                label: 'State',
                name: 'state',
                placeholder: 'Select a state...',
                dataType: 'number',
                fieldType: 'select',
                remote: false,
                filterable: true,
                options: this.states,
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Transaction #',
                value: c && c.id ? `PO${c.id}` : ''
              },
              {
                label: 'Date created',
                value: c.created ? this.formatDateToLocale(c.created) : ''
              },
              {
                label: 'Status',
                value: c.status || ''
              },
              {
                label: 'Remaining',
                value: c.remaining ? `$${formatAmount(c.remaining)}` : ''
              },
              {
                name: 'runningTotal',
                label: 'Relieved',
                prefix: currency ? currency.symbol : '',
                value: c.total_distributed ? formatAmount(c.total_distributed) : ''
              },
              {
                name: 'amount_in_process',
                label: 'Amount in Process',
                dataType: 'string',
                fieldType: 'money',
                isMoney: true,
                prefix: currency ? currency.symbol : '',
                value: c.amount_in_process ? formatAmount(c.amount_in_process) : '0.00'
              },
              {
                name: 'amount_force_closed',
                label: 'Amount Force Closed',
                dataType: 'string',
                fieldType: 'money',
                isMoney: true,
                prefix: currency ? currency.symbol : '',
                value: c.amount_force_closed ? formatAmount(c.amount_force_closed) : '0.00'
              },
              {
                name: 'amount_over_relieved',
                label: 'Amount Over Relieved',
                dataType: 'string',
                fieldType: 'money',
                isMoney: true,
                prefix: currency ? currency.symbol : '',
                value: c.amount_over_relieved ? formatAmount(c.amount_over_relieved) : '0.00'
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.transactionData.inputFields[7].options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
          fields.transactionData.inputFields[7].options.push({
            label: `Ending ${this.selectedPeriod.end}`,
            value: this.selectedPeriod.id,
            selected: true
          })
        }
        return fields
      },
      sumLinesAmounts () {
        if (this.lines && Array.isArray(this.lines) && this.lines.length) {
          const sumOfLines = this.lines.map(line => {
            if (line && line.form) {
              return line.form.remaining_decimal ? parseFloat(line.form.remaining_decimal) : 0
            } else if (line && !line.form) {
              return line.remaining_decimal ? parseFloat(line.remaining_decimal) : 0
            } else {
              return 0
            }
          }).reduce((sum, lineAmt) => sum + lineAmt)
          return sumOfLines ? `$${sumOfLines.toFixed(2)}` : `$0`
        }
        return `$0`
      },
      poCanBeClosed () {
        if (this.form.status === 'CLOSED') return false
        return (!['CLOSED', 'DELETED'].includes(this.form.status))
      },
      poCanBeReopen () {
        const po = this.getPoById(this.$route.params.id)
        return (po && po.status === 'CLOSED' && po.source_type === 'Manual')
      }
    },
    watch: {
      getPos () {
        const newHeader = this.getPoById(this.originalHeader.id)
        if (newHeader) {
          this.originalHeader = Object.assign({}, newHeader)
          this.updateHeaderStatusField()
          this.readOnly = !['DRAFT', 'OPEN', 'AUDITED', 'POSTED'].includes(this.originalHeader.status) || !this.hasEditPermission
        }
      },
      getPoLines () {
        const recent = () => {
          let incomingLines = Object.values(this.getPoLinesByTransactionId(this.$route.params.id))
          let incoming = this.buildOriginalPoLines(incomingLines)
          return incoming.map((line, i) => {
            return { line_number: line.line_number || i + 1, form: Object.assign({}, line) }
          })
        }
        if (this.ready && JSON.stringify(recent()) !== JSON.stringify(this.originalLines)) { // this.ready prevents this logic from running when component is created
          this.originalLines = recent()
          this.lines = recent()
          if (this.$refs && this.$refs['distribution-lines']) {
            this.$refs['distribution-lines'].rebuildLines()
          }
        }
        this.ready = true
      },
      headerDeltas () {
        this.amountHasChanged = Object.keys(this.headerDeltas).includes('amount_decimal')
      }
    },
    async created () {
      await this.customCreated()
      this.lines = sortLines(this.lines)
      this.transactionIsBalanced = true
      this.updateForm(this.form)
      buildPeriodOptionsList(this, false)
      this.$store.dispatch('isEditingForm', false)
    },
    mounted () {
      this.$store.dispatch('setHeaderForm', this.form)
      this.checkPoCanDelete()
    },
    async beforeRouteEnter (to, from, next) {
      const { getPoById } = store.getters
      try {
        const resp = await store.dispatch('fetchPosWithQuery', { query: { id: to.params.id }, storeLines: true })
        let promises = [store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' })]
        if (resp && resp.entities) {
          const deps = await store.dispatch('findDependencies', resp.entities) || []
          promises = [...promises, ...deps]
        }
        await Promise.all(promises)
        const po = getPoById(to.params.id)
        promises = [...FindOrFetchBatchAndPeriod(store, po)]
        await getPoLinesToRelieve(po.id, 'po')
        await loadInitialData()
        if (promises.length) {
          await Promise.all(promises)
        }
        next()
      } catch (e) {
        console.log(e)
        // TODO: notify user
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        sessionStorage.removeItem('paginationInfo')
        sessionStorage.removeItem('paginationQuery')
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }

  /*
    The pane matches the header fields beside it by stretching to the row, rather than being
    sized off the viewport: the row is align="start", and the layout mixin resizes these
    containers on mount, so viewport math came out differently on a route change than on a
    reload.
  */
  .proscan-pane-col {
    padding-right: 12px;
    align-self: stretch;
    display: flex;
  }
  .proscan-pane {
    width: 100%;
    min-height: 420px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Pos/Edit.vue